<template>
  <b-form-group
    label="4. Alamat"
    label-for="alamat"
    label-size="lg"
    label-class="pb-0 pt-0"
  >
    <b-form-textarea id="alamat" v-model="alamatVal" disabled />

    <b-col cols="11" offset-md="1" class="mt-1 pr-0">
      <div v-if="kesesuaianAlamat === '0'">
        <b-form-group
          label="Provinsi"
          label-for="provinsi"
          class="mt-1"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <b-form-select
            id="provinsi"
            v-model="provinsi"
            :state="stateProvinsi"
            :options="dataProvinsi"
            @change="changeProvinsi"
          />
          <b-form-invalid-feedback
            v-for="(error, index) of errorsProvinsi"
            :key="index"
          >
            {{ error.$message }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Kabupaten/Kota"
          label-for="kabKota"
          class="mt-1"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <b-form-select
            id="kabKota"
            v-model="kabKota"
            :state="stateKabKota"
            :options="dataKabKota"
            @change="changeKabKota"
          />
          <b-form-invalid-feedback
            v-for="(error, index) of errorsKabKota"
            :key="index"
          >
            {{ error.$message }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Kecamatan"
          label-for="kecamatan"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <b-form-select
            id="kecamatan"
            v-model="kecamatan"
            :state="stateKecamatan"
            :options="dataKecamatan"
            @change="changeKecamatan"
          />
          <b-form-invalid-feedback
            v-for="(error, index) of errorsKecamatan"
            :key="index"
          >
            {{ error.$message }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Kelurahan"
          label-for="kelurahan"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <b-form-select
            id="kelurahan"
            v-model="kelurahan"
            :state="stateKelurahan"
            :options="dataKelurahan"
            @change="changeKelurahan"
          />
          <b-form-invalid-feedback
            v-for="(error, index) of errorsKelurahan"
            :key="index"
          >
            {{ error.$message }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Jalan"
          label-for="jalan"
          label-size="lg"
          label-class="pb-0 pt-0"
        >
          <b-form-input id="jalan" v-model="jalan" :state="stateJalan" />
          <b-form-invalid-feedback
            v-for="(error, index) of errorsJalan"
            :key="index"
          >
            {{ error.$message }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-row>
          <b-col cols="2">
            <b-form-group
              label="No"
              label-for="noAlamat"
              label-size="lg"
              label-class="pb-0 pt-0"
            >
              <b-form-input
                id="noAlamat"
                v-model="noAlamat"
                :state="stateNoAlamat"
              />
              <b-form-invalid-feedback
                v-for="(error, index) of errorsNoAlamat"
                :key="index"
              >
                {{ error.$message }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="2">
            <b-form-group
              label="RT"
              label-for="rt"
              label-size="lg"
              label-class="pb-0 pt-0"
            >
              <b-form-input
                id="rt"
                v-model="rt"
                :state="stateRt"
                @keydown="changeIntOnly"
              />
              <b-form-invalid-feedback
                v-for="(error, index) of errorsRt"
                :key="index"
              >
                {{ error.$message }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="2">
            <b-form-group
              label="RW"
              label-for="rw"
              label-size="lg"
              label-class="pb-0 pt-0"
            >
              <b-form-input
                id="rw"
                v-model="rw"
                :state="stateRw"
                @keydown="changeIntOnly"
              />
              <b-form-invalid-feedback
                v-for="(error, index) of errorsRw"
                :key="index"
              >
                {{ error.$message }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              label="Kode Pos"
              label-for="kodePos"
              label-size="lg"
              label-class="pb-0 pt-0"
            >
              <b-form-input id="kodePos" v-model="kodePos" disabled />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-form-group>
</template>

<script>
import { ref, watchEffect, watch } from "@vue/composition-api";
import { propsString, propsBoolean, propsArray } from "@/utils/propsTipeData";
import master from "@/composables/master";

export default {
  setup(props, context) {
    const g = context.root;

    let provinsi = ref(null);
    let kabKota = ref(null);
    let kecamatan = ref(null);
    let kelurahan = ref(null);
    let jalan = ref("");
    let noAlamat = ref("");
    let rt = ref("");
    let rw = ref("");
    let kodePos = ref("");

    let dataProvinsi = ref([{ value: null, text: "-- Pilih Salah Satu --" }]);
    let dataKabKota = ref([{ value: null, text: "-- Pilih Salah Satu --" }]);
    let dataKelurahan = ref([{ value: null, text: "-- Pilih Salah Satu --" }]);
    let dataKecamatan = ref([{ value: null, text: "-- Pilih Salah Satu --" }]);

    watch(provinsi, () => {
      context.emit("emitProvinsi", provinsi.value);

      getKabKota();
    });

    watch(kabKota, () => {
      context.emit("emitKabKota", kabKota.value);

      getKecamatan();
    });

    watch(kecamatan, () => {
      context.emit("emitKecamatan", kecamatan.value);

      getKelurahan();
    });

    watch(kelurahan, () => {
      context.emit("emitKelurahan", kelurahan.value);
    });

    watch(jalan, () => {
      context.emit("emitJalan", jalan.value);
    });

    watch(noAlamat, () => {
      context.emit("emitNoAlamat", noAlamat.value);
    });

    watch(rt, () => {
      context.emit("emitRt", rt.value);
    });

    watch(rw, () => {
      context.emit("emitRw", rw.value);
    });

    watch(kodePos, () => {
      context.emit("emitKodePos", kodePos.value);
    });

    watchEffect(() => {
      provinsi.value = props.provinsiVal;
      kabKota.value = props.kabKotaVal;
      kecamatan.value = props.kecamatanVal;
      kelurahan.value = props.kelurahanVal;
      jalan.value = props.jalanVal;
      noAlamat.value = props.noAlamatVal;
      rt.value = props.rtVal;
      rw.value = props.rwVal;
      kodePos.value = props.kodePosVal;
    });

    const changeProvinsi = () => {
      kabKota.value = null;
      kecamatan.value = null;
      kelurahan.value = null;
    };

    const changeKabKota = () => {
      kecamatan.value = null;
      kelurahan.value = null;
    };

    const changeKecamatan = () => {
      kelurahan.value = null;
    };

    const changeKelurahan = () => {
      let index = dataKelurahan.value.findIndex(
        (x) => x.value === kelurahan.value
      );
      kodePos.value = dataKelurahan.value[index].kodepos;
    };

    const changeIntOnly = (value) => {
      context.emit("emitChangeIntOnly", value);
    };

    const getProvinsi = async () => {
      let resProvinsi = await master.getProvinsi(g);
      resProvinsi.unshift({ text: "-- Pilih Salah Satu --", value: null });
      dataProvinsi.value = resProvinsi;
    };

    const getKabKota = async () => {
      let params = {
        provinsi: provinsi.value,
      };
      let resKota = await master.getKota(g, params);
      if (resKota.code == 403)
        resKota = [{ text: "-- Pilih Salah Satu --", value: null }];
      else resKota.unshift({ text: "-- Pilih Salah Satu --", value: null });
      dataKabKota.value = resKota;
    };

    const getKecamatan = async () => {
      let params = {
        provinsi: provinsi.value,
        kota: kabKota.value,
      };
      let resKecamatan = await master.getKecamatan(g, params);
      if (resKecamatan.code == 403 || resKecamatan.code == 401)
        resKecamatan = [{ text: "-- Pilih Salah Satu --", value: null }];
      else
        resKecamatan.unshift({ text: "-- Pilih Salah Satu --", value: null });
      dataKecamatan.value = resKecamatan;
    };

    const getKelurahan = async () => {
      let params = {
        provinsi: provinsi.value,
        kota: kabKota.value,
        kecamatan: kecamatan.value,
      };
      let resKelurahan = await master.getKelurahan(g, params);
      if (resKelurahan.code == 403 || resKelurahan.code == 401)
        resKelurahan = [{ text: "-- Pilih Salah Satu --", value: null }];
      else
        resKelurahan.unshift({ text: "-- Pilih Salah Satu --", value: null });

      dataKelurahan.value = resKelurahan;
    };

    getProvinsi();

    return {
      provinsi,
      kabKota,
      kecamatan,
      kelurahan,
      jalan,
      noAlamat,
      rt,
      rw,
      kodePos,
      dataProvinsi,
      dataKabKota,
      dataKecamatan,
      dataKelurahan,
      changeProvinsi,
      changeKabKota,
      changeKecamatan,
      changeKelurahan,
      changeIntOnly,
    };
  },
  props: {
    alamatVal: propsString,
    kesesuaianAlamat: propsString,
    provinsiVal: propsString,
    stateProvinsi: propsBoolean,
    errorsProvinsi: propsArray,
    kabKotaVal: propsString,
    stateKabKota: propsBoolean,
    errorsKabKota: propsArray,
    kecamatanVal: propsString,
    stateKecamatan: propsBoolean,
    errorsKecamatan: propsArray,
    kelurahanVal: propsString,
    stateKelurahan: propsBoolean,
    errorsKelurahan: propsArray,
    jalanVal: propsString,
    stateJalan: propsBoolean,
    errorsJalan: propsArray,
    noAlamatVal: propsString,
    stateNoAlamat: propsBoolean,
    errorsNoAlamat: propsArray,
    rtVal: propsString,
    stateRt: propsBoolean,
    errorsRt: propsArray,
    rwVal: propsString,
    stateRw: propsBoolean,
    errorsRw: propsArray,
    kodePosVal: propsString,
  },
};
</script>